import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { SxDialogService } from './sx-dialog.service';
import { ReloadPromptComponent } from '@core/components/reload-prompt/reload-prompt.component';
import { SxApplicationInsightsService } from './sx-application-insights.service';
@Injectable()
export class SxErrorHandler extends ErrorHandler {
  constructor(
    private sxDialogService: SxDialogService,
    private aiService: SxApplicationInsightsService) {
    super();
  }

  handleError(error: any): void {

    // If app is newnly deployed chunk loading may fail due to brwser cache.
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      this.sxDialogService.openDialog(ReloadPromptComponent, null);
    }
    console.error('ErrorHandler:', error);
    this.logError(error);
    super.handleError(error);
  }

  public logError(error: Error, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
    if (!properties) {
      properties = {};
    }
    // Logg to Application Insight
    this.aiService.logException(error, null, properties, measurements);
  }
}
